import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import UpIcon from '@material-ui/icons/VerticalAlignTop';
import './JobLog.scss';

const SCROLL_TO_BOTTOM = -2;
const isScrolledAtBottom = (elt) => {
  // console.log(`scrollTop: ${elt.scrollTop}, scrollHeight: ${elt.scrollHeight}, clientHeight: ${elt.clientHeight}: bottom = ${elt.scrollTop >= (elt.scrollHeight - elt.clientHeight)}`);
  return elt.scrollTop >= (elt.scrollHeight - elt.clientHeight);
};

class JobLog extends React.PureComponent {
  static propTypes = {
    jobId: PropTypes.string.isRequired,
    job: PropTypes.shape({ id: PropTypes.string }),
    jobService: PropTypes.shape({
      subscribeJobLog: PropTypes.func.isRequired,
      unsubscribeJobLog: PropTypes.func.isRequired,
      fetchFullLog: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    job: undefined,
  }

  constructor(props) {
    super(props);

    this.state = {
      logStatus: undefined,
    };
    this.mounted = false;
    this.logRef = React.createRef();
    this.logSuscriber = logStatus => this.updateLog(logStatus);
    this.handleFullLog = this.handleFullLog.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    const { jobId, job, jobService } = this.props;
    jobService.subscribeJobLog(jobId, job, this.logSuscriber);
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    // https://reactjs.org/docs/react-component.html#getsnapshotbeforeupdate
    if (!this.state.logStatus || !this.logRef.current) return SCROLL_TO_BOTTOM;
    const { logStatus } = prevState || {};
    if (!logStatus) return this.state.logStatus && SCROLL_TO_BOTTOM || null;
    if (!logStatus.full && this.state.logStatus.full) {
      // We just downloaded the complete log, make the scroll position change so
      // that the first visible log line does not change.
      return this.logRef.current.scrollTop - this.logRef.current.scrollHeight;
    }
    if (logStatus.log.length !== this.state.logStatus.length) {
      // Log has been added at the bottom
      // If scroll is not at the bottom, we want to keep the first visible log line
      if (!isScrolledAtBottom(this.logRef.current)) {
        return this.logRef.current.scrollTop;
      }
      // We stay at the bottom
      return this.logRef.current.scrollTop - this.logRef.current.scrollHeight;
    }
    // Nothing has changed, we keep the current scroll position
    return this.logRef.current.scrollTop;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const textarea = this.logRef.current;
    if ((snapshot !== null) && textarea) {
      if (snapshot === SCROLL_TO_BOTTOM) {
        textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
      } else if (snapshot >= 0) {
        textarea.scrollTop = snapshot;
      } else {
        textarea.scrollTop = textarea.scrollHeight + snapshot;
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    const { jobService, jobId } = this.props;
    if (this.state.logStatus) {
      jobService.unsubscribeJobLog(jobId, this.logSuscriber);
    }
  }

  handleFullLog() {
    const { jobService, jobId } = this.props;
    jobService.fetchFullLog(jobId);
  }

  updateLog(logStatus) {
    this.setState({ logStatus });
  }

  render() {
    const { jobId } = this.props;
    const { logStatus } = this.state;
    return (
      <div className="grb-joblog">
        <section className="grb-joblog-body">
          {(!logStatus || logStatus.error) && (
            <div className="grb-joblog-error">No log available</div>
          )}
          {logStatus && !logStatus.error && !logStatus.full && (
            <div className="grb-joblog-collapsed-line">
              <Button onClick={this.handleFullLog} id="grb-joblog-full-btn">
                <UpIcon />...Full Log
              </Button>
            </div>
          )}
          {logStatus && (
            <textarea
              className={classnames('grb-joblog-text', logStatus.full && 'grb-joblog-text-full')}
              ref={this.logRef}
              value={logStatus.log}
              readOnly
            />
          )}
        </section>
      </div>
    );
  }
}

export default JobLog;
